import { z } from 'zod';
import { bindInputMaker } from '../util.make-input.js';

const makeInput = bindInputMaker();
const inTableCheckboxInput = makeInput({
  entry: {
    schema: z.object({
      type: z.literal("in-table-checkbox").default("in-table-checkbox"),
      checked: z.boolean().default(false)
    }),
    shouldValidate: (node, entry) => node.validation.shouldBeChecked || !!entry?.checked,
    validate: (node, entry) => node.validation.shouldBeChecked === entry.checked,
    parseLegacyDetailItem: (item, context) => {
      if (["WriteAnswers"].includes(context.relatedTask.taskType) && ["InTable"].includes(context.relatedTask.answerType ?? "") && typeof item === "boolean") {
        return [context.relatedInput?.id ?? `${context.relatedTask.id}-${context.indexInDetails}`, {
          type: "in-table-checkbox",
          checked: item
        }];
      }
    }
  },
  schema: z.object({
    type: z.literal("Checkbox"),
    correctAnswer: z.boolean()
  }),
  postprocessSchemaInput: ({
    correctAnswer
  }, context) => {
    return {
      id: `${context.taskId}-${context.rowIndex}-${context.index}`,
      nodeType: "in-table-checkbox-input",
      meta: {
        rowIndex: context.rowIndex
      },
      validation: {
        shouldBeChecked: correctAnswer
      }
    };
  }
});

export { inTableCheckboxInput };
//# sourceMappingURL=input.checkbox.js.map
